import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  AtsCandidateEmailActionDelaysEnum,
  AtsJobPostingSettingsSmartActionsItemDetailsFragment,
} from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { ApplicationPhaseTag } from 'modules/ats/components/ApplicationPhaseTag'

interface Props {
  item: AtsJobPostingSettingsSmartActionsItemDetailsFragment
}

export const ItemDetails = ({ item }: Props) => {
  return (
    <Box gap="s16" width="full">
      <ItemDetailsRow title={i18n.t('ats.job_posting_settings.smart_actions.phase')}>
        <Box flexDirection="row" gap="s8" flexWrap="wrap" flexGrow>
          {item.atsApplicationPhases.map((phase) => (
            <ApplicationPhaseTag key={phase.id} applicationPhase={phase} />
          ))}
        </Box>
      </ItemDetailsRow>

      <ItemDetailsRow title={i18n.t('ats.job_posting_settings.smart_actions.sender')}>
        <Text.Normal weight="medium" color="grey1000">
          {capitalize(sendFromLabel(item.emailFrom))}
        </Text.Normal>
      </ItemDetailsRow>

      {item.delay !== 'now' && (
        <ItemDetailsRow title={i18n.t('ats.job_posting_settings.smart_actions.delay')}>
          <Text.Normal weight="medium" color="grey1000">
            {capitalize(delayLabel(item.delay))}
          </Text.Normal>
        </ItemDetailsRow>
      )}
    </Box>
  )
}

const ItemDetailsRow = ({ title, children }: React.PropsWithChildren<{ title: string }>) => {
  return (
    <Box flexDirection="row" gap="s12">
      <Box minWidth="s120">
        <Text.Normal>{title}</Text.Normal>
      </Box>
      {children}
    </Box>
  )
}

const delayLabel = (delay: AtsCandidateEmailActionDelaysEnum) => {
  switch (delay) {
    case 'now':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_now')
    case 'two_hours':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_later_2_hours')
    case 'four_hours':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_later_4_hours')
    case 'six_hours':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_later_6_hours')
    case 'today_at_six_pm':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_today_6_pm')
    case 'tomorrow_at_nine_am':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_tomorrow')
    case 'next_monday_at_nine_am':
      return i18n.t('ats.candidates.messages.email_actions_delayed_messages.send_next_monday')
    default:
      return delay
  }
}

const sendFromLabel = (sendFrom: string) => {
  switch (sendFrom) {
    case 'no_reply':
      return i18n.t('ats.smart_actions.sender_options.no_reply')
    case 'conversation':
      return i18n.t('ats.smart_actions.sender_options.conversation')
    default:
      return sendFrom
  }
}
